<template lang="pug">
.zone.content-part.table-content.iframe-header
    .title-row
        slot(name="icon")
    .header-chart-line
    .toolbar-row
        Search(:placeholder="placeHolder", @doSearch="doSearch", ref="search")
        a.btn.btn-icon.pull-right(v-on:click="showAdd")
            i.fa.fa-plus-circle
            | {{addText}}
    .data-row
        data-table(:url="listAPI", :initrequest="initrequest", @getdata="setData", :fixed="true", :needpagination="false")
            thead
                tr
                    th(width="30%") {{firstColText}} 
                    th.right(width="30%") 过滤PV
                    th.right(width="20%") 生效时间
                    th.center(width="20%") 操作
            tbody
                tr(v-show="isShowAdd")
                    td(colspan="4", style="text-align: left")
                        v-input(
                            v-model="newurl",
                            size="big",
                            :placeholder="placeHolder",
                            :rules="rules[pattern]",
                            ref="jsAddInput"
                        )
                        .btn.btn-primary(@click="addRecord") 保存
                        .btn.btn-white(@click="cancelAdd") 取消

                tr(v-for="(row, index) in dataList")
                    td(width="30%", :title="row[ urltype ]") {{ row[ urltype ] }}
                    td.right(width="30%") {{ row.pv }}
                    td.right(width="20%") {{ row.effecttime }}
                    td.center(width="20%")
                        i.fa.fa-eye.fa-lg(@click="listHistory(row)", :style="{marginRight: '8px'}", title="查看")
                        i.fa.fa-trash-o.fa-lg(@click="deleteRecord(row, index)", title="删除")
    v-pagination(:total="total", :pn="pageNum", ps="10", @updatepage="changePage")    
</template>
<script>
export default {
    props: {
        pattern: String,
        urltype: String,
        params: String,
        placeHolder: String,
        addText: String,
        firstColText: String
    },
    data(){
        return {
            dataList: [],
            pageNum: 1,
            total: 0,
            newurl: "",
            isShowAdd: false,
            initrequest: false,
            rules: {
                ip: {
                    maxlength: 16,
                    pattern: /^((25[0-5]|2[0-4]\d|[01]?\d\d?)($|(?!\.$)\.)){4}$/
                },
                url: {
                    maxlength: 200,
                    pattern: /(http[s]{0,1}):\/\/[a-zA-Z0-9\.\-]+\.([a-zA-Z]{2,4})(:\d+)?(\/[a-zA-Z0-9\.\-~!@#$%^&*+?:_\/=<>]*)?/
                }
            }
        }
    },
    computed: {
        listAPI() {
            if (/[?&]domainId=\d+/.test(this.params)) {
                return `/api/${this.urltype}/list?${this.params}&pg=${this.pageNum}&ps=10`;
            } else {
                return false;
            }
        }
    },
    watch: {
        params(newVal, oldVal) {
            if (newVal !== oldVal) {
                let match = newVal.match(/[?&]domainId\=(\d+)/);
                this.domainId = match && match[1];
                this.pageNum = 1;
            }
        }
    },
    methods: {
        showAdd() {
            this.isShowAdd = true;
            this.$nextTick(() => {
                let input = this.$refs.jsAddInput.$el.querySelector('input');
                input && input.focus();
            });
        },

        setData(list, total){
            list = list.sort((a, b) => {
                return new Date(b.effecttime) - new Date(a.effecttime);
            });
            this.total = total;
            this.dataList = list || [];
        },
        doSearch(keyword){
            keyword = _.trim(keyword);

            // if (!keyword) {
            //     return this.$Modal.warn('内容不能为空！');
            // }

            let url = this.listAPI + `&${this.urltype}=${keyword}`;
            this.$http.get(url).then(r => r.data).then(({ errno, errmsg, list, total }) => {
                if (errno) {
                    this.$Modal.warn(errmsg);
                }
                this.setData(list, total);
            }).catch((e) => {
                this.$Modal.warn('请求失败');
            });
        },

        listHistory(row){
            this.$emit("listHistory", this.urltype, row);
        },

        deleteRecord(row, index){
            this.$Modal.confirm('确定删除？', (confirm) => {
                if (!confirm) return;

                let url = `/api/${this.urltype}/delete?domainId=${this.domainId}&id=${row.id}`;

                this.$http.get(url).then(r => r.data).then(({ errno, errmsg }) => {
                    if (errno) {
                        this.$Modal.warn(errmsg);
                    } else {
                        this.dataList.splice(index, 1);
                        this.total--;
                    }
                }).catch((e) => {
                    this.$Modal.warn('删除失败');
                });
            });
        },

        addRecord(){
            if (!_.trim(this.$refs.jsAddInput.value))  {
                return this.$Modal.warn('内容不能为空！');
            }

            let validity = this.$refs.jsAddInput.validate();
            if (!validity.valid) return;

            let urltype = this.urltype;
            let url = `/api/${urltype}/add?domainId=${this.domainId}&${urltype}=${this.newurl}`;
            this.$http.get(url).then(r => r.data).then(({ errno, errmsg, data }) => {
                if (errno) {
                    this.$Modal.warn(errmsg);
                }
                if (data) {
                    this.cancelAdd();
                    this.dataList.unshift(data);
                    this.total++;
                }
            }).catch((e) => {
                this.$Modal.warn('添加失败');
                callback && callback(null);
            });
        },
        cancelAdd() {
            this.isShowAdd = false;
            this.newurl = '';
        },
        changePage(pn) {
            this.pageNum = pn;
        }
    }
}
</script>
<style>
.toolbar-row {
    margin: 10px 0;
}
td > .fa:hover {
    color: #56bf8b;
}
.btn-icon .fa-plus-circle {
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// filter_table.vue?300abff6